import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
export default function Pricing(){
  return (
    <Container sx={{py:4}}>
      <Typography variant="h4" gutterBottom>Pricing</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card><CardContent>
            <Typography variant="h6">Starter</Typography>
            <Typography>₹499 / month</Typography>
            <Button component={RouterLink} to="/subscribe" variant="contained" sx={{mt:2}}>Subscribe</Button>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card><CardContent>
            <Typography variant="h6">Pro</Typography>
            <Typography>₹1299 / month</Typography>
            <Button component={RouterLink} to="/subscribe" variant="contained" sx={{mt:2}}>Subscribe</Button>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card><CardContent>
            <Typography variant="h6">Annual (Pro)</Typography>
            <Typography>₹12990 / year</Typography>
            <Button component={RouterLink} to="/subscribe" variant="contained" sx={{mt:2}}>Subscribe</Button>
          </CardContent></Card>
        </Grid>
      </Grid>
    </Container>
  );
}
